import React, { useEffect, useState } from "react";
import fakeData from "../../FakeData/data.json";
import Vehicle from "../Vehicle/Vehicle";
import "./Home.css"

const Home = () => {
  useEffect(() => {
    setData(fakeData);
  }, []);
  const [data, setData] = useState([]);
  return (
    <section className="homepage">
      <div className="container">
        <div className="row vehicles">
          {data.map((td) => (
            <Vehicle vehicle={td} key={td.id}></Vehicle>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Home;
